import Image from "next/image";

import curveLineDown from "@/assets/img/ombudsman/right_curve.svg";
import { Bullet } from "@/components/Bullet/Bullet";
import { Box, Stack } from "@mui/material";

import { styles } from "./styles";
import { SecurityScamSectionLeftImageProps } from "./types";

export const SecurityScamSectionLeftImage: React.FC<SecurityScamSectionLeftImageProps> = ({
  src,
  bottomBulletColor,
  topBulletColor,
  hideLeftTopLine
}) => {
  if (!src) {
    return null;
  }

  return (
    <Stack minWidth="400px" minHeight="350px" position="relative" bgcolor="white">
      {!hideLeftTopLine ? (
        <Box position="relative" width="100%" minHeight="60px" display={{ xs: "none", md: "inherit" }}>
          <Image
            src={curveLineDown}
            alt=""
            style={{
              position: "absolute",
              backgroundColor: "#FFF",
              zIndex: 2,
              top: "14px",
              right: "-29px",
              transform: "scaleX(-1)"
            }}
          />
        </Box>
      ) : null}

      <Box minWidth="400px" position="relative" height="fit-content" mt="-3px">
        <svg width="100%" height="100%" viewBox="0 0 467 394" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="clip">
              <path d="M465.5 392.5V1.5H1.50003V169.405L124.759 330.65C154.557 369.632 200.821 392.5 249.887 392.5H465.5Z" />
            </clipPath>
          </defs>
          <image href={src} width="100%" height="100%" preserveAspectRatio="xMidYMid slice" clipPath="url(#clip)" />
          <path
            d="M465.5 392.5V1.5H1.50003V169.405L124.759 330.65C154.557 369.632 200.821 392.5 249.887 392.5H465.5Z"
            stroke="#0045B5"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <Box sx={{ width: 32, height: 32, position: "absolute", right: -15, top: -12 }}>
          <Bullet fillColor={topBulletColor} />
        </Box>

        <Box sx={{ width: 32, height: 32, position: "absolute", right: -15, bottom: { md: "-12px", xs: "-8px" }, zIndex: 2 }}>
          <Bullet fillColor={bottomBulletColor} />
        </Box>
      </Box>

      <Box position="relative" width="100%" minHeight="60px" height="100%" display={{ xs: "none", md: "inherit" }}>
        <Image
          src={curveLineDown}
          alt=""
          style={{
            transform: "rotate(-90deg) scaleX(-1)",
            position: "absolute",
            bottom: 0,
            right: "-30px",
            backgroundColor: "#FFF",
            zIndex: 2
          }}
        />
        <Box css={styles.vertical_line} />
        <Box css={styles.hotizontal_line} />
      </Box>
    </Stack>
  );
};
